import { type FC } from "react";

import { Button } from "@styled/button";
import { Modal } from "@styled/modal";
import { ModalClose } from "@styled/modal_close";
import { ModalContent } from "@styled/modal_content";
import { ModalFooter } from "@styled/modal_footer";
import { ModalHeader } from "@styled/modal_header";
import { ModalTitle } from "@styled/modal_title";

import { NewProjectFields, useNewProjectForm } from "./new_project_form";

// The modal wrapper around the shared New Case form. Fields, validation and the
// build mutation live in `useNewProjectForm` so this and the guided empty
// state's inline panel stay identical.
export const NewProjectModal: FC<{
  onClose(): void;
}> = ({ onClose }) => {
  const form = useNewProjectForm({ onCreated: onClose });

  return (
    <Modal onClose={onClose}>
      <form onSubmit={form.onSubmit}>
        <ModalHeader>
          <ModalTitle>New Case</ModalTitle>
          <ModalClose onClose={onClose} />
        </ModalHeader>

        <ModalContent>
          <NewProjectFields form={form} />
        </ModalContent>

        <ModalFooter>
          <Button type="button" color="white" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" color="indigo" size="sm" loading={form.loading}>
            Create case
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
